/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Supporting } from './Supporting';
import {
    SupportingFromJSON,
    SupportingFromJSONTyped,
    SupportingToJSON,
} from './Supporting';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface GetSupporting
 */
export interface GetSupporting {
    /**
     * 
     * @type {number}
     * @memberof GetSupporting
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof GetSupporting
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof GetSupporting
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof GetSupporting
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof GetSupporting
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof GetSupporting
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof GetSupporting
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Supporting}
     * @memberof GetSupporting
     */
    data?: Supporting;
}

/**
 * Check if a given object implements the GetSupporting interface.
 */
export function instanceOfGetSupporting(value: object): value is GetSupporting {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function GetSupportingFromJSON(json: any): GetSupporting {
    return GetSupportingFromJSONTyped(json, false);
}

export function GetSupportingFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSupporting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : SupportingFromJSON(json['data']),
    };
}

export function GetSupportingToJSON(value?: GetSupporting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': SupportingToJSON(value.data),
    };
}

